import { SearchField } from '@/modules/common/components';
import {
  ChangeTypes,
  EventFiltersType,
  FiltersChangeType,
} from '@/modules/events/hooks';

interface TableFiltersProps {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}

export function InventoryTableFilters({
  filters,
  onFilters,
}: TableFiltersProps) {
  return (
    <div className="flex gap-4">
      <SearchField
        placeholder="Search by category, name, or nickname"
        defaultValue={filters.search || ''}
        className="w-full min-w-[320px] max-w-[400px]"
        onChange={(value) =>
          onFilters({ search: value || undefined }, ChangeTypes.Debounce)
        }
      />
    </div>
  );
}
